import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["onetime", "onetimeExclHidden", "slider"]
  static values  = { vatPercentage: Number }

  // Sending the upfront along pins it, so moving the slider leaves it untouched.
  update() {
    this.onetimeExclHiddenTarget.value = this.onetimeExclCents()
    this.reload({ device_bundle_cents: this.sliderTarget.value, onetime_excl_cents: this.onetimeExclCents() })
  }

  setOnetime() {
    this.onetimeExclHiddenTarget.value = this.onetimeExclCents()
    this.reload({ onetime_excl_cents: this.onetimeExclCents() })
  }

  // The field is filled in including vat, while the url carries the amount excluding it.
  onetimeExclCents() {
    const value = this.onetimeTarget.value
    const incl  = value === "" ? 0 : parseFloat(value) * 100

    return Math.round(incl / (1 + this.vatPercentageValue / 100))
  }

  // Inside the order modal this card lives in the auto-submitting configurator
  // form, so resubmitting it (rather than navigating a hand-built url) keeps
  // every other selection on the form intact.
  reload(params) {
    const form = this.element.closest("form")

    if (form) {
      form.requestSubmit()
      return
    }

    const url = new URL(window.location.href)

    Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value))

    window.location.href = url.toString()
  }
}
